import React from 'react';

function IconBase({ children, title }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      {children}
    </svg>
  );
}

export function IconQr() {
  return (
    <IconBase title="QR">
      <path
        d="M4 4h6v6H4V4Zm2 2v2h2V6H6Zm8-2h6v6h-6V4Zm2 2v2h2V6h-2ZM4 14h6v6H4v-6Zm2 2v2h2v-2H6Zm10-2h2v2h-2v-2Zm2 2h2v4h-4v-2h2v-2Zm-6 0h2v2h-2v-2Zm0 2h2v2h-2v-2Zm2 2h2v2h-2v-2Z"
        fill="currentColor"
        opacity="0.9"
      />
    </IconBase>
  );
}

export function IconMenu() {
  return (
    <IconBase title="Menu">
      <path
        d="M6 5h12v2H6V5Zm0 6h12v2H6v-2Zm0 6h12v2H6v-2Z"
        fill="currentColor"
        opacity="0.9"
      />
    </IconBase>
  );
}

export function IconSpark() {
  return (
    <IconBase title="Spark">
      <path
        d="M12 2l1.2 4.4L18 8l-4.8 1.6L12 14l-1.2-4.4L6 8l4.8-1.6L12 2Zm7 7l.7 2.5L22 12l-2.3.5L19 15l-.7-2.5L16 12l2.3-.5L19 9ZM4.5 12l.9 3.2L9 16l-3.6.8L4.5 20l-.9-3.2L0 16l3.6-.8.9-3.2Z"
        fill="currentColor"
        opacity="0.9"
      />
    </IconBase>
  );
}

export function IconBolt() {
  return (
    <IconBase title="Fast">
      <path
        d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z"
        fill="currentColor"
        opacity="0.9"
      />
    </IconBase>
  );
}

export function IconPhone() {
  return (
    <IconBase title="Mobile">
      <path
        d="M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm0 3v14h8V5H8Zm4 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        fill="currentColor"
        opacity="0.9"
      />
    </IconBase>
  );
}

export function IconShield() {
  return (
    <IconBase title="Trust">
      <path
        d="M12 2 20 6v6c0 5-3.4 9.4-8 10-4.6-.6-8-5-8-10V6l8-4Zm0 4.2L6 8.7V12c0 3.7 2.3 6.9 6 7.8 3.7-.9 6-4.1 6-7.8V8.7L12 6.2Z"
        fill="currentColor"
        opacity="0.9"
      />
    </IconBase>
  );
}
